// This file should contain routing only,
// Providers please go App.tsx
// import { MessageManager } from '@airwallex/core/dist/widget-auth-sdk';
import { useFlowContext } from '@airwallex-dev-scale/core/dist/hosted-flow-utils';
import { lazy, Suspense, useContext, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { PageLoading } from '@/components/fullPage';
import { TranslationProvider } from '@/components/translationProvider';
import { useAppFlowContext } from '@/contexts/appFlow';
import { ContainerContext } from '@/contexts/containerProps';
import { PermissionWrapper } from '@/contexts/permission';

// const SelectReservePage = lazy(() => import('./selectReserve'));

const IncrementalPaymentActivationPage = lazy(
  () => import('./incrementalPaymentActivation'),
);
const InitialPaymentActivationPage = lazy(
  () => import('./initialPaymentActivation'),
);

export const useAppBasePath = () => {
  const flowContext = useFlowContext();
  // @ts-ignore
  const { environmentVariables } = useContext(ContainerContext);

  if (flowContext?.id) {
    return environmentVariables.appPath?.replace('app1', 'app');
  }

  return `/${window.location.pathname.split('/')[1] || 'app'}`;
};

export const Pages = () => {
  const { isEmbedded } = useAppFlowContext();
  const { eventEmitter } = useContext(ContainerContext);
  const [isReady, setIsReady] = useState(!isEmbedded);

  const appBasePath = useAppBasePath();

  useEffect(() => {
    if (isEmbedded) {
   /*    MessageManager.receiveToken(() => {
        setIsReady(true);
      }); */
      eventEmitter?.emit('#getAuthToken');
    }
  }, []);

  if (!isReady) {
    return <PageLoading />;
  }

  return (
    <TranslationProvider>
      <BrowserRouter basename={appBasePath + '/kyb'}>
        <Suspense fallback={<PageLoading />}>
          <Routes>
            <Route
              path="/payment-activation"
              element={
                // @ts-ignore
                <PermissionWrapper>
                  <InitialPaymentActivationPage />
                </PermissionWrapper>
              }
            ></Route>
            <Route
              path="/payment-activation/add"
              element={
                // @ts-ignore
                <PermissionWrapper>
                  <IncrementalPaymentActivationPage />
                </PermissionWrapper>
              }
            ></Route>
            <Route
              path="/select-reserve"
              element={
                // @ts-ignore
                <PermissionWrapper>
               {/*    <SelectReservePage /> */}
                </PermissionWrapper>
              }
            ></Route>
            <Route
              path="*"
              element={<Navigate to={'/payment-activation'} replace />}
            ></Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TranslationProvider>
  );
};
